const LABELS = {
  location_picker_select: {
    $i18n: true,
    ar: 'اختيار موقع',
    az: 'Məkan seçin',
    ca: 'Tria ubicació',
    da: 'Vælg placering',
    de: 'Wählen Sie einen Ort',
    en: 'Choose location',
    es: 'Elegir ubicación',
    fi: 'Valitse sijainti',
    fr: "Choisissez l'emplacement",
    hi: 'स्थान चुनें',
    hu: 'Hely kiválasztása',
    id: 'Pilih lokasi',
    it: 'Scegli la posizione',
    ja: '場所を選択してください',
    lv: 'Izvēlieties atrašanās vietu',
    nl: 'Kies locatie',
    pl: 'Wybierz lokalizację',
    pt: 'Escolha a localização',
    ro: 'Alege locație',
    ru: 'Выберите местоположение',
    sv: 'Välj plats',
    tr: 'Konum seçk',
    uk: 'Виберіть місце розташування',
  },
  form_submit_button: {
    $i18n: true,
    ar: 'إرسال',
    az: 'Göndər',
    ca: 'Envia',
    da: 'Indsend',
    de: 'Speichern',
    en: 'Submit',
    es: 'Guardar',
    fi: 'Lähetä',
    fr: 'Enregistrer',
    hi: 'सबमिट करें',
    hu: 'Küldés',
    id: 'Kirim',
    it: 'Invia',
    ja: '送信',
    lv: 'Iesniegt',
    nl: 'Opslaan',
    pl: 'Ratować',
    pt: 'Submeter',
    ro: 'Trimite',
    ru: 'Отправить',
    sv: 'Skicka in',
    tr: 'Göndermek',
    uk: 'Надіслати',
  },
  cancel: {
    $i18n: true,
    ar: 'إلغاء',
    az: 'İmtina et',
    ca: 'Cancel·lar',
    da: 'Afbestille',
    de: 'Abbrechen',
    en: 'Cancel',
    es: 'Cancelar',
    fi: 'Peruuttaa',
    fr: 'Annuler',
    hi: 'रद्द करें',
    hu: 'Mégse',
    id: 'Batal',
    it: 'Annulla',
    ja: 'キャンセル',
    lv: 'Atcelt',
    nl: 'Annuleren',
    pl: 'Anulować',
    pt: 'Cancelar',
    ro: 'Anulare',
    ru: 'Отменить',
    sv: 'Annullera',
    tr: 'İptal etmek',
    uk: 'Скасувати',
  },
  text_input_placeholder: {
    $i18n: true,
    ar: 'اكتب رسالة ...',
    az: 'Bir mesaj yazın…',
    ca: 'Escriu un missatge…',
    da: 'Skriv en besked…',
    de: 'Nachricht schreiben…',
    en: 'Type a message…',
    es: 'Escriba mensaje…',
    fi: 'Kirjoita viesti…',
    fr: 'Tapez le message…',
    hi: 'एक संदेश टाइप करें…',
    hu: 'Írjon üzenetet…',
    id: 'Ketik pesan…',
    it: 'Scrivi un messaggio…',
    ja: 'メッセージを入力してください…',
    lv: 'Ierakstiet ziņojumu…',
    nl: 'Typ een bericht…',
    pl: 'Wpisz wiadomość…',
    pt: 'Escreva uma mensagem…',
    ro: 'Scrieți un mesaj…',
    ru: 'Введите сообщение…',
    sv: 'Skriv ett meddelande…',
    tr: 'Bir mesaj yazın…',
    uk: 'Введіть повідомлення…',
  },
  new_conversation: {
    $i18n: true,
    ar: 'محادثة جديدة',
    az: 'Yeni müzakirə',
    ca: 'Nova conversa',
    da: 'Ny samtale',
    de: 'Neues Gespräch',
    en: 'New conversation',
    es: 'Nueva conversación',
    fi: 'Uusi keskustelu',
    fr: 'Nouvelle conversation',
    hi: 'नई बातचीत',
    hu: 'Új beszélgetés',
    id: 'Percakapan baru',
    it: 'Nuova conversazione',
    ja: '新しい会話',
    lv: 'Jauna saruna',
    nl: 'Nieuw gesprek',
    pl: 'Nowa rozmowa',
    pt: 'Nova conversa',
    ro: 'Conversație nouă',
    ru: 'Новый разговор',
    sv: 'Ny konversation',
    tr: 'Yeni görüşme',
    uk: 'Нова розмова',
  },
  conversations: {
    $i18n: true,
    ar: 'المحادثات',
    az: 'Müzakirələr',
    ca: 'Les teves converses',
    da: 'Dine samtaler',
    de: 'Ihre Gespräche',
    en: 'Your Conversations',
    es: 'Conversaciones anteriores',
    fi: 'Sinun keskustelusi',
    fr: 'Vos conversations',
    hi: 'आपकी बातचीत',
    hu: 'Saját beszélgetések',
    id: 'Percakapan Anda',
    it: 'Le tue conversazioni',
    ja: 'あなたの会話',
    lv: 'Jūsu sarunas',
    nl: 'Uw gesprekken',
    pl: 'Twoje rozmowy',
    pt: 'As suas conversas',
    ro: 'Conversațiile tale',
    ru: 'Ваши разговоры',
    sv: 'Dina konversationer',
    tr: 'Konuşmalarınız',
    uk: 'Ваші розмови',
  },
  show_all: {
    $i18n: true,
    ar: 'عرض الكل',
    az: 'Hamısını göstər',
    ca: 'Mostra-ho tot',
    da: 'vis alt',
    de: 'zeige alles',
    en: 'show all',
    es: 'mostrar todo',
    fi: 'näytä kaikki',
    fr: 'montre tout',
    hi: 'सभी दिखाओ',
    hu: 'mutasd mindet',
    id: 'Tampilkan semua',
    it: 'mostra tutto',
    ja: 'すべて表示',
    lv: 'parādīt visu',
    nl: 'toon alles',
    pl: 'pokaż wszystko',
    pt: 'mostrar tudo',
    ro: 'arată tot',
    ru: 'Показать все',
    sv: 'visa allt',
    tr: 'hepsini göster',
    uk: 'Покажи все',
  },
  conversation_cta: {
    $i18n: true,
    ar: 'بدء محادثة',
    az: 'Müzakirə başlat',
    ca: 'Comença una conversa',
    da: 'Start en samtale',
    de: 'Eine Konversation beginnen',
    en: 'Start a conversation',
    es: 'Iniciar una conversación',
    fi: 'Aloita keskustelu',
    fr: 'Commencer une conversation',
    hi: 'बातचीत शुरू करें',
    hu: 'Indítson egy beszélgetést',
    id: 'Mulai percakapan',
    it: 'Inizia una conversazione',
    ja: '会話を始める',
    lv: 'Sāciet sarunu',
    nl: 'Begin een gesprek',
    pl: 'Rozpocznij rozmowę',
    pt: 'Iniciar uma conversa',
    ro: 'Începe o conversație',
    ru: 'Начать разговор',
    sv: 'Starta en konversation',
    tr: 'Konuşma başlat',
    uk: 'Почніть розмову',
  },
  team_message: {
    $i18n: true,
    ar: 'يستجيب فريقنا عادة في 5 دقائق.',
    az: 'Bizim komandamız ən az 5 dəqiqə ərzində cavab verir.',
    ca: 'Normalment, el nostre equip respon en 5 minuts.',
    da: 'Vores team reagerer typisk på 5 minutter.',
    de: 'Unser Team antwortet normalerweise innerhalb von 5 Minuten.',
    en: 'Our team typically responds in 5 minutes.',
    es: 'Nuestro equipo responde normalmente en 5 minutos.',
    fi: 'Tiimimme vastaa yleensä 5 minuutissa.',
    fr: 'Notre équipe répond normalement en 5 minutes.',
    hi: 'हमारी टीम आमतौर पर 5 मिनट में प्रतिक्रिया देती है।',
    hu: 'Csapatunk általában 5 percen belül válaszol.',
    id: 'Tim kami biasanya merespons dalam 5 menit.',
    it: 'Il nostro team in genere risponde in 5 minuti.',
    ja: '私たちのチームは通常5分以内に返信します。',
    lv: 'Mūsu komanda parasti atbild 5 minūšu laikā.',
    nl: 'Ons team reageert gewoonlijk binnen 5 minuten.',
    pl: 'Nasz zespół zwykle odpowiada w ciągu 5 minut.',
    pt: 'A nossa equipa responde normalmente em 5 minutos.',
    ro: 'Echipa noastră răspunde de obicei în 5 minute.',
    ru: 'Наша команда обычно отвечает в течение 5 минут.',
    sv: 'Vårt team svarar vanligtvis inom 5 minuter.',
    tr: 'Ekibimiz genellikle 5 dakika içinde yanıt verir.',
    uk: 'Наша команда зазвичай відповідає протягом 5 хвилин.',
  },
  whatsapp: {
    $i18n: true,
    en: 'WhatsApp',
  },
  phone: {
    $i18n: true,
    ar: 'هاتف',
    az: 'Telefon',
    ca: 'Telèfon',
    da: 'Telefon',
    de: 'Telefon',
    en: 'Telephone',
    es: 'Teléfono',
    fi: 'Puhelin',
    fr: 'Téléphone',
    hi: 'टेलीफोन',
    hu: 'Telefon',
    id: 'Telepon',
    it: 'Telefono',
    ja: '電話',
    lv: 'Tālrunis',
    nl: 'Telefoon',
    pl: 'Telefon',
    pt: 'Telefone',
    ro: 'Telefon',
    ru: 'Телефон',
    sv: 'Telefon',
    tr: 'Telefon',
    uk: 'Телефон',
  },
  contact_form: {
    $i18n: true,
    ar: 'رسالة',
    az: 'Mesaj',
    ca: 'Missatge',
    da: 'Besked',
    de: 'Nachricht',
    en: 'Message',
    es: 'Mensaje',
    fi: 'Viesti',
    fr: 'Message',
    hi: 'संदेश',
    hu: 'Üzenet',
    id: 'Pesan',
    it: 'Messaggio',
    ja: 'メッセージ',
    lv: 'Ziņojums',
    nl: 'Bericht',
    pl: 'Wiadomość',
    pt: 'Mensagem',
    ro: 'Mesaj',
    ru: 'Сообщение',
    sv: 'Meddelande',
    tr: 'İleti',
    uk: 'повідомлення',
  },
  or_contact_via: {
    $i18n: true,
    ar: 'أو التواصل عبر',
    az: 'və ya aracılığıyla əlaqə saxlayın',
    ca: 'o contacta via',
    da: 'eller kontakt via',
    de: 'oder kontaktieren Sie uns über',
    en: 'or get in touch via',
    es: 'o ponte en contacto a través de',
    fi: 'tai ota yhteyttä kautta',
    fr: 'ou contactez-nous via',
    hi: 'या संपर्क करें',
    hu: 'vagy lépjen kapcsolatba',
    id: 'atau hubungi melalui',
    it: 'o contattaci tramite',
    ja: 'または次の方法でご連絡ください',
    lv: 'vai sazinieties ar',
    nl: 'of neem contact op via',
    pl: 'lub skontaktuj się z nami przez',
    pt: 'ou entre em contato via',
    ro: 'sau contactați prin',
    ru: 'или свяжитесь с нами через',
    sv: 'eller hör av dig via',
    tr: 'veya aracılığıyla iletişime geçin',
    uk: "або зв'яжіться через",
  },
  whatsapp_cta: {
    $i18n: true,
    ar: 'أرسل رسالة إلى $1:',
    az: '$1-ə bir mesaj göndər:',
    ca: 'Envia un missatge a $1:',
    da: 'Send en besked til $1:',
    de: 'Senden Sie eine Nachricht an $1:',
    en: 'Send a message to $1:',
    es: 'Enviar un mensaje a $1:',
    fi: 'Lähetä viesti numerolle $1:',
    fr: 'Envoyer un message à $1:',
    hi: '$1 को एक संदेश भेजें:',
    hu: 'Küldj üzenetet $1 számára:',
    id: 'Kirim pesan ke $1:',
    it: 'Invia un messaggio a $1:',
    ja: '$1にメッセージを送る:',
    lv: 'Nosūtīt ziņu uz $1:',
    nl: 'Stuur een bericht naar $1:',
    pl: 'Wyślij wiadomość do $1:',
    pt: 'Enviar uma mensagem para $1:',
    ro: 'Trimite un mesaj la $1:',
    ru: 'Отправить сообщение на $1:',
    sv: 'Skicka ett meddelande till $1:',
    tr: "$1'e bir mesaj gönder:",
    uk: 'Надіслати повідомлення до $1:',
  },
  send: {
    $i18n: true,
    ar: 'لتوجيه',
    az: 'Göndər',
    ca: 'Enviar',
    da: 'Sende',
    de: 'Senden',
    en: 'Send',
    es: 'Enviar',
    fi: 'Lähettää',
    fr: 'Envoyer',
    hi: 'भेजें',
    hu: 'Küldés',
    id: 'Kirim',
    it: 'Inviare',
    ja: '送信',
    lv: 'Sūtīt',
    nl: 'Verstuur',
    pl: 'Wysłać',
    pt: 'Enviar',
    ro: 'Trimite',
    ru: 'Отправить',
    sv: 'Skicka',
    tr: 'Göndermek',
    uk: 'Надіслати',
  },
  close: {
    $i18n: true,
    ar: 'لإغلاق',
    az: 'Bağla',
    ca: 'Tancar',
    da: 'At lukke',
    de: 'Schließen',
    en: 'Close',
    es: 'Cerrar',
    fi: 'Sulkea',
    fr: 'Fermer',
    hi: 'बंद करें',
    hu: 'Bezárás',
    id: 'Tutup',
    it: 'Chiudere',
    ja: '閉じる',
    lv: 'Aizvērt',
    nl: 'Sluiten',
    pl: 'Zamknąć',
    pt: 'Fechar',
    ro: 'Închide',
    ru: 'Закрыть',
    sv: 'För nära',
    tr: 'Kapatmak',
    uk: 'Закрити',
  },
  phone_cta: {
    $i18n: true,
    ar: 'اتصل بنا على',
    az: 'Bizimlə əlaqə saxlayın',
    ca: "Truca'ns a",
    da: 'Ring til os på',
    de: 'Rufen Sie uns an:',
    en: 'Call us on',
    es: 'Llámanos al',
    fi: 'Soita meille numeroon',
    fr: 'Appelez nous au',
    hi: 'हमें कॉल करें',
    hu: 'Hívjon minket',
    id: 'Hubungi kami di',
    it: 'Chiamaci al numero',
    ja: 'お電話でのお問い合わせ',
    lv: 'Zvaniet mums uz',
    nl: 'Bel ons op',
    pl: 'Zadzwoń do nas na',
    pt: 'Ligue para nós no',
    ro: 'Sunați-ne la',
    ru: 'Позвоните нам по номеру',
    sv: 'Ring oss på',
    tr: 'Bizi arayın',
    uk: 'Зателефонуйте нам за',
  },
  contact_form_cta: {
    $i18n: true,
    ar: 'اترك لنا رسالة وسنتواصل معك قريبًا.',
    az: 'Bizə mesaj yazın və biz tezliklə sizinlə əlaqə saxlayacağıq',
    ca: "Deixa'ns un missatge i ens posarem en contacte amb tu aviat.",
    da: 'Efterlad os en besked, så kontakter vi snart.',
    de: 'Hinterlassen Sie uns eine Nachricht und wir werden uns bei Ihnen melden.',
    en: 'Leave us a message and we will be in touch shortly.',
    es: 'Déjanos un mensaje y te responderemos pronto.',
    fi: 'Jätä meille viesti, niin olemme pian yhteydessä.',
    fr: 'Laissez-nous un message et nous y reviendrons bientôt.',
    hi: 'हमें एक संदेश छोड़ें और हम जल्द ही आपसे संपर्क करेंगे।',
    hu: 'Hagyjon üzenetet és hamarosan felvesszük Önnel a kapcsolatot.',
    id: 'Tinggalkan pesan dan kami akan segera menghubungi Anda.',
    it: 'Lasciaci un messaggio e ti contatteremo a breve.',
    ja: 'メッセージを残してください。すぐにご連絡いたします。',
    lv: 'Atstājiet mums ziņu un mēs drīz ar jums sazināsimies.',
    nl: 'Laat een bericht achter, dan komen we snel bij u terug.',
    pl: 'Zostaw wiadomość za sobą, a potem wrócimy do Ciebie wkrótce.',
    pt: 'Deixe-nos uma mensagem e entraremos em contacto em breve.',
    ro: 'Lăsați-ne un mesaj și vă vom contacta în curând.',
    ru: 'Оставьте нам сообщение, и мы скоро с вами свяжемся.',
    sv: 'Lämna ett meddelande till oss så hör vi av oss inom kort.',
    tr: 'Bize bir mesaj bırakın, kısa sürede sizinle iletişime geçeceğiz.',
    uk: 'Залиште нам повідомлення, і ми незабаром зв’яжемося.',
  },
  contact_form_thanks: {
    $i18n: true,
    ar: 'شكرا على رسالتك، سنتواصل معك قريبا.',
    az: 'Mesajınız üçün təşəkkürlər, biz sizinlə ən yaxın zamanda əlaqə saxlayacağıq.',
    ca: 'Gràcies pel teu missatge, ens posarem en contacte amb tu aviat.',
    da: 'Tak for din besked, vi vil snart have kontakt.',
    de: 'Vielen Dank für Ihre Nachricht, wir werden uns in Kürze bei Ihnen melden.',
    en: 'Thank you for your message, we will soon be in touch.',
    es: 'Gracias por tu mensaje, pronto nos pondremos en contacto.',
    fi: 'Kiitos viestistäsi, olemme pian yhteydessä.',
    fr: 'Merci pour votre message, nous vous recontacterons sous peu.',
    hi: 'आपके संदेश के लिए धन्यवाद, हम जल्द ही आपसे संपर्क करेंगे।',
    hu: 'Köszönjük üzenetét, hamarosan felvesszük Önnel a kapcsolatot.',
    id: 'Terima kasih atas pesan Anda, kami akan segera menghubungi Anda.',
    it: 'Grazie per il tuo messaggio, ti ricontatteremo presto.',
    ja: 'メッセージをありがとうございます。すぐにご連絡いたします。',
    lv: 'Paldies par jūsu ziņojumu, mēs drīz ar jums sazināsimies.',
    nl: 'Bedankt voor uw bericht, we nemen spoedig contact met u op.',
    pl: 'Dziękujemy za wiadomość, wkrótce się z Tobą skontaktujemy.',
    pt: 'Obrigado pela sua mensagem, entraremos em contacto em breve.',
    ro: 'Vă mulțumim pentru mesaj, vă vom contacta în curând.',
    ru: 'Спасибо за ваше сообщение, мы скоро с вами свяжемся.',
    sv: 'Tack för ditt meddelande, vi kommer snart att kontakta dig.',
    tr: 'Mesajınız için teşekkür ederiz, yakında sizinle iletişime geçeceğiz.',
    uk: 'Дякуємо за повідомлення, ми скоро зв’яжемося.',
  },
  name_placeholder: {
    $i18n: true,
    ar: 'اسمك',
    az: 'Adınız',
    ca: 'El teu nom',
    da: 'Dit navn',
    de: 'Ihr Name',
    en: 'Your name',
    es: 'Su nombre',
    fi: 'Sinun nimesi',
    fr: 'Votre nom',
    hi: 'आपका नाम',
    hu: 'Az Ön neve',
    id: 'Nama Anda',
    it: 'Il tuo nome',
    ja: 'あなたの名前',
    lv: 'Tavs vārds',
    nl: 'Uw naam',
    pl: 'Twoje imię',
    pt: 'O seu nome',
    ro: 'Numele tău',
    ru: 'Ваше имя',
    sv: 'Ditt namn',
    tr: 'Adınız',
    uk: "Твоє ім'я",
  },
  email_placeholder: {
    $i18n: true,
    ar: 'بريدك الالكتروني',
    az: 'E-poçt ünvanınız',
    ca: 'El teu correu electrònic',
    da: 'Din email',
    de: 'Deine E-Mail',
    en: 'Your email',
    es: 'Tu correo electrónico',
    fi: 'Sähköpostisi',
    fr: 'Votre e-mail',
    hi: 'तुम्हारा ईमेल',
    hu: 'Az Ön e-mail-je',
    id: 'Email Anda',
    it: 'La tua email',
    ja: 'あなたのメール',
    lv: 'Tavs e-pasts',
    nl: 'Uw e-mailadres',
    pl: 'Twój adres email',
    pt: 'O seu email',
    ro: 'Email-ul tău',
    ru: 'Ваш адрес электронной почты',
    sv: 'Din email',
    tr: 'E-posta adresiniz',
    uk: 'Ваша електронна адреса',
  },
  phone_placeholder: {
    $i18n: true,
    ar: 'رقم تليفونك',
    az: 'Telefon nömrəniz',
    ca: 'El teu número de telèfon',
    da: 'Dit telefonnummer',
    de: 'Deine Telefonnummer',
    en: 'Your phone number',
    es: 'Su número de teléfono',
    fi: 'Puhelinnumerosi',
    fr: 'Votre numéro de téléphone',
    hi: 'आपका फोन नंबर',
    hu: 'Az Ön telefonszáma',
    id: 'Nomor telepon Anda',
    it: 'Il tuo numero di telefono',
    ja: 'あなたの電話番号',
    lv: 'Jūsu tālruņa numurs',
    nl: 'Uw telefoonnummer',
    pl: 'Twój numer telefonu',
    pt: 'O seu número de telefone',
    ro: 'Numărul tău de telefon',
    ru: 'Ваш номер телефона',
    sv: 'Ditt telefonnummer',
    tr: 'Telefon numaran',
    uk: 'Ваш номер телефону',
  },
  call: {
    $i18n: true,
    ar: 'اتصل الان',
    az: 'İndi zəng edin',
    ca: 'Truca ara',
    da: 'Ring nu',
    de: 'Jetzt anrufen',
    en: 'Call now',
    es: 'Llama ahora',
    fi: 'Soita nyt',
    fr: 'Appelle maintenant',
    hi: 'अब कॉल करें',
    hu: 'Hívás most',
    id: 'Panggil sekarang',
    it: 'Chiamare ora',
    ja: '今すぐ電話',
    lv: 'Zvani tagad',
    nl: 'Bel nu',
    pl: 'Zadzwoń teraz',
    pt: 'Ligue agora',
    ro: 'Sună acum',
    ru: 'Звоните сейчас',
    sv: 'Ring nu',
    tr: 'Şimdi ara',
    uk: 'Подзвони зараз',
  },
  conversation_cta_unavailable: {
    $i18n: true,
    ar: 'اتصل بنا',
    az: 'Bizimlə əlaqə saxlayın',
    ca: "Contacta'ns",
    da: 'Kontakt os',
    de: 'Kontaktiere uns',
    en: 'Contact us',
    es: 'Contáctenos',
    fi: 'Ota meihin yhteyttä',
    fr: 'Contactez-nous',
    hi: 'संपर्क करें',
    hu: 'Vegye fel velünk a kapcsolatot',
    id: 'Hubungi kami',
    it: 'Contattaci',
    ja: 'お問い合わせ',
    lv: 'Sazinies ar mums',
    nl: 'Neem contact met ons op',
    pl: 'Skontaktuj się z nami',
    pt: 'Contacte-nos',
    ro: 'Contactați-ne',
    ru: 'Свяжитесь с нами',
    sv: 'Kontakta oss',
    tr: 'Bize Ulaşın',
    uk: "Зв'яжіться з нами",
  },
  team_message_unavailable: {
    $i18n: true,
    ar: 'حاليا، نحن غير متاحين للدردشة الحية.',
    az: 'Hal-hazırda, biz canlı chat üçün mövcud deyilik.',
    ca: 'Actualment, no estem disponibles per al xat en directe.',
    da: 'I øjeblikket er vi ikke tilgængelige for live chat.',
    de: 'Derzeit sind wir nicht für den Live-Chat verfügbar.',
    en: 'Currently, we are not available for live chat.',
    es: 'Actualmente, no estamos disponibles para chatear en vivo.',
    fi: 'Tällä hetkellä emme ole käytettävissä live-chatissa.',
    fr: 'Actuellement, nous ne sommes pas disponibles pour le chat en direct.',
    hi: 'वर्तमान में, हम लाइव चैट के लिए उपलब्ध नहीं हैं।',
    hu: 'Jelenleg nem vagyunk elérhetők élő csevegéshez.',
    id: 'Saat ini, kami tidak tersedia untuk obrolan langsung.',
    it: 'Al momento non siamo disponibili per la chat dal vivo.',
    ja: '現在、ライブチャットはご利用いただけません。',
    lv: 'Pašlaik mēs neesam pieejami tiešraides tērzēšanai.',
    nl: 'Momenteel zijn wij niet beschikbaar voor livechat.',
    pl: 'Obecnie nie jesteśmy dostępni na czat na żywo.',
    pt: 'Atualmente, não estamos disponíveis para chat ao vivo.',
    ro: 'Momentan, nu suntem disponibili pentru chat live.',
    ru: 'В настоящее время мы недоступны для живого чата.',
    sv: 'För närvarande är vi inte tillgängliga för livechatt.',
    tr: 'Şu anda canlı sohbet için uygun değiliz.',
    uk: 'Наразі ми не доступні для живого чату.',
  },
  leave_message_button: {
    $i18n: true,
    ar: 'ترك رسالة',
    az: 'Mesajınızı qaldırın',
    ca: 'Deixa un missatge',
    da: 'Læg en besked',
    de: 'Eine Nachricht hinterlassen',
    en: 'Leave a message',
    es: 'Dejar un mensaje',
    fi: 'Jätä viesti',
    fr: 'Laisser un message',
    hi: 'संदेश छोड़ें',
    hu: 'Hagyj üzenetet',
    id: 'Tinggalkan pesan',
    it: 'Lasciate un messaggio',
    ja: 'メッセージを残す',
    lv: 'Atstāj ziņu',
    nl: 'Laat een bericht achter',
    pl: 'Zostaw wiadomość',
    pt: 'Deixar uma mensagem',
    ro: 'Lasă un mesaj',
    ru: 'Оставить сообщение',
    sv: 'Lämna ett meddelande',
    tr: 'Mesaj bırakın',
    uk: 'Залишити повідомлення',
  },
  privacy_policy_label: {
    $i18n: true,
    ar: 'سياسة الخصوصية',
    az: 'Məxfilik siyasəti',
    ca: 'Política de privacitat',
    da: 'Fortrolighedspolitik',
    de: 'Datenschutzrichtlinie',
    en: 'Privacy policy',
    es: 'Política de privacidad',
    fi: 'Tietosuojakäytäntö',
    fr: 'Politique de confidentialité',
    hi: 'गोपनीयता नीति',
    hu: 'Adatvédelmi irányelvek',
    id: 'Kebijakan pribadi',
    it: 'Politica sulla riservatezza',
    ja: 'プライバシーポリシー',
    lv: 'Privātuma politika',
    nl: 'Privacybeleid',
    pl: 'Polityka prywatności',
    pt: 'Política de Privacidade',
    ro: 'Politica de confidențialitate',
    ru: 'Политика конфиденциальности',
    sv: 'Integritetspolicy',
    tr: 'Gizlilik Politikası',
    uk: 'Політика конфіденційності',
  },
  privacy_policy_acceptance_label: {
    $i18n: true,
    ar: 'أنا أوافق على <a target="_blank" noreferrer href="$1">سياسة الخصوصية</a>',
    az: 'Məxfilik siyasətinə əminəm <a target="_blank" noreferrer href="$1">Məxfilik siyasəti</a>',
    ca: 'Accepto la <a target="_blank" noreferrer href="$1">Política de privacitat</a>',
    da: 'Jeg accepterer <a target="_blank" noreferrer href="$1">Fortrolighedspolitik</a>',
    de: 'Ich stimme der <a target="_blank" noreferrer href="$1">Datenschutzrichtlinie</a> zu',
    en: 'I accept the <a target="_blank" noreferrer href="$1">privacy policy</a>',
    es: 'Acepto la <a target="_blank" noreferrer href="$1">Política de privacidad</a>',
    fi: 'Hyväksyn <a target="_blank" noreferrer href="$1">tietosuojavaltion</a>',
    fr: 'J’accepte la <a target="_blank" noreferrer href="$1">politique de confidentialité</a>',
    hi: 'मैं गोपनीयता नीति को स्वीकारता हूं <a target="_blank" noreferrer href="$1">गोपनीयता नीति</a>',
    hu: 'Elfogadom az <a target="_blank" noreferrer href="$1">adatvédelmi irányelveket</a>',
    id: 'Saya menerima <a target="_blank" noreferrer href="$1">kebijakan privasi</a>',
    it: 'Accetto la <a target="_blank" noreferrer href="$1">politica sulla riservatezza</a>',
    ja: '私は<a target="_blank" noreferrer href="$1">プライバシーポリシー</a>に同意します',
    lv: 'Esmu piekrītīs <a target="_blank" noreferrer href="$1">privātuma politika</a>',
    nl: 'Ik accepteer de <a target="_blank" noreferrer href="$1">privacy policy</a>',
    pl: 'Akceptuję <a target="_blank" noreferrer href="$1">politykę prywatności</a>',
    pt: 'Aceito a <a target="_blank" noreferrer href="$1">Política de privacidade</a>',
    ro: 'Accept <a target="_blank" noreferrer href="$1">politica de confidențialitate</a>',
    ru: 'Я принимаю <a target="_blank" noreferrer href="$1">политику конфиденциальности</a>',
    sv: 'Jag accepterar <a target="_blank" noreferrer href="$1">integritetspolicy</a>',
    tr: 'Kabul ediyorum <a target="_blank" noreferrer href="$1">gizlilik politikası</a>',
    uk: 'Я приймаю <a target="_blank" noreferrer href="$1">політику конфіденційності</a>',
  },
  whatsapp_qr_cta: {
    $i18n: true,
    ar:
      'امسح الرمز ضوئيًا باستخدام هاتفك المحمول لبدء الدردشة أو استخدام <a target="_blank" noreferrer href="$1">Whatsapp Web</a>.',
    az:
      'Məkan kodunu mobil telefonunuzla taraxın və ya <a target="_blank" noreferrer href="$1">Whatsapp Web</a> istifadə edin.',
    ca:
      'Escaneja el codi amb el teu telèfon mòbil per començar a xatejar o fes servir <a target="_blank" noreferrer href="$1">Whatsapp Web</a>.',
    da:
      'Scan koden med din mobiltelefon for at begynde at chatte eller bruge <a target="_blank" noreferrer href="$1">Whatsapp Web</a>.',
    de:
      'Scannen Sie den Code mit Ihrem Mobiltelefon, um mit dem Chatten zu beginnen oder <a target="_blank" noreferrer href="$1">Whatsapp Web</a> zu nutzen.',
    en:
      'Scan the code with your mobile phone to start chatting or use <a target="_blank" noreferrer href="$1">Whatsapp Web</a>.',
    es:
      'Escanea el código con tu teléfono móvil para empezar a chatear o utilizar <a target="_blank" noreferrer href="$1">Whatsapp Web</a>.',
    fi:
      'Skannaa koodi matkapuhelimellasi aloittaaksesi chattailun tai käyttääksesi <a target="_blank" noreferrer href="$1">Whatsapp Web</a>iä.',
    fr:
      'Scannez le code avec votre téléphone mobile pour commencer à discuter ou utiliser <a target="_blank" noreferrer href="$1">Whatsapp Web</a>.',
    hi:
      'चैटिंग शुरू करने के लिए अपने मोबाइल फोन से कोड को स्कैन करें या <a target="_blank" noreferrer href="$1">व्हाट्सएप वेब</a> का उपयोग करें।',
    hu:
      'Szkennelje be a kódot a mobiltelefonjával a csevegés megkezdéséhez, vagy használja a <a target="_blank" noreferrer href="$1">Whatsapp Webet</a>.',
    id:
      'Pindai kode dengan ponsel Anda untuk mulai mengobrol atau gunakan <a target="_blank" noreferrer href="$1">Whatsapp Web</a>.',
    it:
      'Scansiona il codice con il tuo cellulare per iniziare a chattare o utilizzare <a target="_blank" noreferrer href="$1">Whatsapp Web</a>.',
    ja:
      'チャットを始めるには、携帯電話でコードをスキャンするか、<a target="_blank" noreferrer href="$1">Whatsapp Web</a>を使用してください。',
    lv:
      'Skenējiet kodu ar savu mobilo tālruni, lai sāktu tērzēšanu vai izmantotu <a target="_blank" noreferrer href="$1">Whatsapp Web</a>.',
    nl:
      'Scan de code met uw mobiele telefoon om te beginnen met chatten of gebruik <a target="_blank" noreferrer href="$1">Whatsapp Web</a>.',
    pl:
      'Zeskanuj kod za pomocą telefonu komórkowego, aby uruchomić czat lub użyć <a target="_blank" noreferrer href="$1">WhatsApp Web</a>.',
    pt:
      'Escaneie o código com o seu telemóvel para começar a conversar ou use o <a target="_blank" noreferrer href="$1">Whatsapp Web</a>.',
    ro:
      'Scanați codul cu telefonul mobil pentru a începe să comunicați sau folosiți <a target="_blank" noreferrer href="$1">Whatsapp Web</a>.',
    ru:
      'Отсканируйте код с помощью мобильного телефона, чтобы начать чат или использовать <a target="_blank" noreferrer href="$1">WhatsApp Web</a>.',
    sv:
      'Skanna koden med din mobiltelefon för att börja chatta eller använda <a target="_blank" noreferrer href="$1">Whatsapp Web</a>.',
    tr:
      'Sohbete başlamak veya <a target="_blank" noreferrer href="$1">Whatsapp Web</a>\'i kullanmak için kodu cep telefonunuzla tarayın.',
    uk:
      'Відскануйте код за допомогою мобільного телефону, щоб почати спілкуватися в чаті або використовувати <a target="_blank" noreferrer href="$1">Whatsapp Web</a>.',
  },
  open_in_new_window: {
    $i18n: true,
    ar: 'فتح في نافذة جديدة',
    az: 'Yeni pəncərədə aç',
    ca: 'Obre en una finestra nova',
    da: 'Åbn i nyt vindue',
    de: 'In neuem Fenster öffnen',
    en: 'Open in new window',
    es: 'Abrir en ventana nueva',
    fi: 'Avaa uudessa ikkunassa',
    fr: 'Ouvrir dans une nouvelle fenêtre',
    hi: 'नई विंडो में खोलें',
    hu: 'Megnyitás új ablakban',
    id: 'Buka di jendela baru',
    it: 'Apri in nuova finestra',
    ja: '新しいウィンドウで開く',
    lv: 'Atvērt jaunā logā',
    nl: 'Openen in nieuw venster',
    pl: 'Otwórz w nowym oknie',
    pt: 'Abrir em nova janela',
    ro: 'Deschide în fereastră nouă',
    ru: 'Открыть в новом окне',
    sv: 'Öppna i nytt fönster',
    tr: 'Yeni pencerede aç',
    uk: 'Відкрити в новому вікні',
  },
  expand_window: {
    $i18n: true,
    ar: 'تكبير النافذة',
    az: 'Pəncərəni böyüt',
    ca: 'Ampliar la finestra',
    da: 'Gør vinduet større',
    de: 'Fenster vergrößern',
    en: 'Enlarge',
    es: 'Agrandar',
    fi: 'Suurenna',
    fr: 'Agrandir',
    hi: 'विंडो बड़ा करें',
    hu: 'Nagyítás',
    id: 'Perbesar',
    it: 'Ingrandisci',
    ja: '大きくする',
    lv: 'Palielināt',
    nl: 'Vergroten',
    pl: 'Powiększ',
    pt: 'Aumentar',
    ro: 'Mărește',
    ru: 'Увеличить',
    sv: 'Förstora',
    tr: 'Büyüt',
    uk: 'Збільшити',
  },
  shrink_window: {
    $i18n: true,
    ar: 'تصغير النافذة',
    az: 'Pəncərəni kiçilt',
    ca: 'Reduir la finestra',
    da: 'Gør vinduet mindre',
    de: 'Fenster verkleinern',
    en: 'Shrink',
    es: 'Reducir',
    fi: 'Pienennä',
    fr: 'Réduire',
    hi: 'विंडो छोटा करें',
    hu: 'Kicsinyítés',
    id: 'Perkecil',
    it: 'Riduci',
    ja: '小さくする',
    lv: 'Samazināt',
    nl: 'Verkleinen',
    pl: 'Pomniejsz',
    pt: 'Reduzir',
    ro: 'Micșorează',
    ru: 'Уменьшить',
    sv: 'Förminska',
    tr: 'Küçült',
    uk: 'Зменшити',
  },
}

let _uiLocale = null

export function determineUILocale(initialLocale, bot) {
  const { locale } = bot
  const extra_locales = bot.extra_locales || bot.extraLocales
  const user = initialLocale || navigator.language.replace(/\-.*$/, '')
  if (user === locale || extra_locales.indexOf(user) >= 0) {
    _uiLocale = user
  } else {
    _uiLocale = locale
  }
  if (typeof LABELS.cancel[_uiLocale] === 'undefined') {
    _uiLocale = 'en'
  }
  return _uiLocale
}

export function localePreflist(userLocale, bot) {
  const prefList = [bot.locale].concat(bot.extra_locales)
  if (prefList.indexOf(userLocale) >= 0) {
    prefList.unshift(userLocale)
  }
  return prefList
}

export function resolveTranslations(value, userLocale, bot) {
  if (typeof value !== 'object') {
    return value
  }

  if (!bot) {
    // userLocale is a list
    return resolveTranslationsLocales(value, userLocale)
  }

  return resolveTranslationsLocales(value, localePreflist(userLocale, bot))
}

export function resolveTranslationsLocales(value, locales) {
  if (typeof value !== 'object') {
    return value
  }

  if (value === null) {
    return null
  }

  if (Array.isArray(value)) {
    return value.map(v => resolveTranslations(v, locales))
  }
  // regular object
  if (value.$i18n === true) {
    // this is a translation object
    return (
      (locales || ['en']).reduce((translated, lang) => translated || value[lang], null) ||
      value[Object.keys(value).filter(k => k.match(/^[a-z]/))[0]]
    )
  }

  Object.keys(value).forEach(k => {
    value[k] = resolveTranslations(value[k], locales)
  })
  return value
}

export function fixedLabel(key, prefList) {
  return resolveTranslations(LABELS[key], prefList.concat(['en']))
}

export function textDirectionClass(locale) {
  if (locale.startsWith('ar') || locale.startsWith('he')) {
    return 'rtl'
  }

  return 'ltr'
}
